import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IHeader } from '../_models/IHeader';
import { AppComponent } from 'app/app.component';
import { CommunicationService } from 'app/_services/communication.service';
import { GridController } from 'app/_controllers/gridController';
import { ISettings } from 'app/_models/ISettings';
import { FilterController } from 'app/_controllers/filterController';
import { DialogHeaderComponent } from 'app/dialog-header-component/dialog-header.component';
import { IconDefinition, faPen, faFloppyDisk, faGrip } from '@fortawesome/free-solid-svg-icons';
import { CdkDrag, CdkDragHandle, CdkDropList, CdkDropListGroup, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'column-component',
  templateUrl: './column.component.html',
  styleUrls: ['./column.component.css']  
})
export class ColumnComponent implements OnInit {
  //#region Fields & Icons
  @Input() settings: ISettings;
  @Input() headers: IHeader[] = [];
  @Input() nodeId: string;
  @Input() userId: string;
  @Input() username: string;
  @Input() viewName: string;
  @ViewChild(DialogHeaderComponent) dialogHeader: DialogHeaderComponent;
  updated: boolean = false;
  updatedHeaders: IHeader[] = [];
  faPen: IconDefinition = faPen;
  faFloppyDisk: IconDefinition = faFloppyDisk;
  faGrip: IconDefinition = faGrip;
  //#endregion

  constructor(
    public app: AppComponent,
    private gridController: GridController,
    private filterController: FilterController,
    private communicationService: CommunicationService
  ) { }

  ngOnInit(): void { }

  update(headerToUpdate: string, event: any): void {
    this.updated = true;
    let index = this.headers.findIndex(header => header.caption === headerToUpdate);
    this.headers[index].visible = event.checked;
    let header = this.updatedHeaders.find(header => header.caption == this.headers[index].caption);
    if (!header) this.updatedHeaders.push(this.headers[index]);
    if (this.dialogHeader) this.dialogHeader.closeEnabled = false;
  }

  save(): void {
    if (!this.updated) {
      this.app.alertInfo(this.app.translations.ALERT_Info_NothingToSave);
      return;
    }

    if (this.headers.filter(header => header.visible).length == 0) {
      this.app.alertError(this.app.translations.ALERT_Error_AllHeadersHidden);
      return;
    }

    this.adjustSortAndFilters();
    this.app.showLoader();
    this.gridController.saveLayout(this.nodeId, this.viewName, this.username, this.headers).then(result => {
      if (result) {
        this.app.hideLoader();
        this.communicationService.closeDialog();
        this.communicationService.refreshAll();
      }
    });
  }

  adjustSortAndFilters(): void {
    let sortedByHeader = this.headers.find(header => header.sortedBy);
    if (this.viewName == 'master' && sortedByHeader && !sortedByHeader.visible)
      localStorage.removeItem(`qx_sort_${this.nodeId}`);
    else if (this.viewName != 'master' && sortedByHeader && !sortedByHeader.visible)
      localStorage.removeItem(`qx_sort_${this.nodeId}_${this.viewName}`);

    let filters = [];
    let filterString = '';
    if (this.viewName == 'master' && localStorage.getItem(`qx_filters_${this.nodeId}`)) {
      filters = JSON.parse(localStorage.getItem(`qx_filters_${this.nodeId}`)).filters;
      filterString = JSON.parse(localStorage.getItem(`qx_filters_${this.nodeId}`)).filterString;
    } else if (this.viewName != 'master' && localStorage.getItem(`qx_filters_${this.nodeId}_${this.viewName}`)) {
      filters = JSON.parse(localStorage.getItem(`qx_filters_${this.nodeId}_${this.viewName}`)).filters;
      filterString = JSON.parse(localStorage.getItem(`qx_filters_${this.nodeId}_${this.viewName}`)).filterString;
    }

    if (filters.length > 0) {
      this.updatedHeaders.forEach(header => {
        let filter = filters.find(filter => filter.caption == header.caption);
        if (!filter && header.visible) {
          filters.push(this.filterController.createFilter(header));
        } else {
          let filterIndex = filters.findIndex(filter => filter.field == header.field);
          if (filterIndex != -1) filters.splice(filterIndex, 1);
        }
      })

      filterString = this.filterController.buildFilterString(filters);
      if (this.viewName == 'master')
        localStorage.setItem(`qx_filters_${this.nodeId}`, JSON.stringify({ filterString: filterString, filters: filters }));
      else
        localStorage.setItem(`qx_filters_${this.nodeId}_${this.viewName}`, JSON.stringify({ filterString: filterString, filters: filters }));
    }
  }

  drop(event: any): void {
    moveItemInArray(this.headers, event.previousIndex, event.currentIndex);
    this.updated = true;
  }
}